import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DrawCollapseDirectiveSharedModule } from '@shared/core/directives/drawCollapse/draw-collapse.directive.shared.module';

import { NavBarLogoModule } from './navBarLogo';
import { NavBarUcpModule } from './navBarUcp';

import { NavBarComponent } from './nav-bar.shared.component';

@NgModule({
    declarations: [
        NavBarComponent,
    ],
    imports: [
        CommonModule,
        NavBarLogoModule,
        NavBarUcpModule,
        DrawCollapseDirectiveSharedModule,
    ],
    exports: [
        NavBarComponent,
    ],
    providers: [],
})
export class NavBarModule { }
